import React, { useEffect } from "react";
// import { useParams } from "react-router-dom";
import {
  // useAppGameDetailsSelector,
  // useAppRodeoEventDetailsSelector,
  useStatusMsgSelector,
} from "src/_common/hooks/selectors/eventSelector";
import { useCommonApi } from "src/_common/hooks/actions/common/appCommonApiHook";
import { handleApiCall } from "src/_config";
import { toast } from "react-toastify";
import Marquee from "react-fast-marquee";
// import { decryptText } from "./Encryptor";
// import { APPLICATION_GLOBAL_SLUG, SOCKET_CHANNEL } from "src/_config";
// import { useSocketChannel } from "src/_common/hooks/custom/useSocketChannel";
import { useAppEventAction } from "src/_common/hooks/actions/event/appEventActionHook";

const StatusMessage = () => {
  // const { rodeoEventId } = useParams<any>();
  // const gameDetails = useAppGameDetailsSelector();
  // const gameStatusText = useAppGameStatusTextSelector();
  // const [statusMessageText, setStatusMessageText] = useState<string>("");
  // const rodeoEventDetails = useAppRodeoEventDetailsSelector();
  // const statusMsgDataFromSocket = useSocketChannel<any>(SOCKET_CHANNEL.STATUS_MSG);
  const eventAction = useAppEventAction();
  const commonApi = useCommonApi();
  const statusMsg = useStatusMsgSelector();

  // Fetch game status text on component mount
  useEffect(() => {
    const params = {
      gameId: 1, // Using 1 as RodeoPicks Id as specified
    };

    handleApiCall(
      commonApi.callGetGameStatusText,
      params,
      (_resp: any) => {
        // Success callback - data is already stored in Redux via saga
        //console.log("Game status text fetched successfully:", _resp);
        if (_resp.status_text) {
          eventAction.statusMsg(_resp);
        }
      },
      toast,
      false,
      true,
    );
  }, []);

  // useEffect(() => {
  //   if (rodeoEventId) {
  //     if (rodeoEventDetails?.active_status_message?.text) {
  //       setStatusMessageText(rodeoEventDetails?.active_status_message?.text);
  //     } else if (gameDetails?.status_text) {
  //       setStatusMessageText(gameDetails?.status_text);
  //     }
  //   } else if (gameStatusText?.status_text) {
  //     // Use the new API data from Redux
  //     setStatusMessageText(gameStatusText.status_text);
  //   } else {
  //     setStatusMessageText("");
  //   }
  // }, [rodeoEventId, rodeoEventDetails, gameDetails, gameStatusText]);

  // useEffect(() => {
  //   if (statusMsgDataFromSocket) {
  //     //console.log("statusMsgDataFromSocket", statusMsgDataFromSocket);
  //     if (statusMsgDataFromSocket?.site == APPLICATION_GLOBAL_SLUG) {
  //       if (statusMsgDataFromSocket?.rodeo_event_id == 0) {
  //         eventAction.gameStatusText(statusMsgDataFromSocket?.status_text);
  //       } else if (statusMsgDataFromSocket?.rodeo_event_id == decryptText(rodeoEventId + "")) {
  //         eventAction.rodeoEventStatusText(statusMsgDataFromSocket?.status_text);
  //       }
  //     }
  //   }
  // }, [statusMsgDataFromSocket]);

  return (
    <section>
      {statusMsg ? (
        <div className="next_Rodeo">
          <div className="container">
            <div className="d-flex gap-3 next_Rodeo_Inner">
              <div className="next_Rodeo_Label d-none">Notice:</div>
              <div className="next_Rodeo_Marque">
                <Marquee direction="left" loop={0} pauseOnHover={true} speed={60}>
                  {statusMsg?.status_text}
                </Marquee>
              </div>
            </div>
          </div>
        </div>
      ) : null}
    </section>
  );
};

export default StatusMessage;
